import { apiClient } from '@/services/api';
import type { LoginCredentials, LoginResponse, UserInfoDto } from '../types';
import type { ApiResult } from '@/types';

export const authApi = {
  // Login user
  login: (credentials: LoginCredentials): Promise<ApiResult<LoginResponse>> => {
    return apiClient.post<LoginCredentials, LoginResponse>(
      '/api/auth/login',
      credentials
    );
  },

  // Logout user
  logout: (): Promise<ApiResult<void>> => {
    return apiClient.post<'', void>('/api/auth/logout', '');
  },

  // Check auth status
  checkAuthStatus: (): Promise<ApiResult<UserInfoDto>> => {
    return apiClient.get<UserInfoDto, undefined>('/api/auth/status');
  },
};

export * from '../types';
